/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { FieldsPageEntrypointProps } from './FieldsPage.entrypoint.types.tsx';

type Queries = {};

type FieldSettingsPageEntrypointComponent = EntryPointComponent<
	Queries,
	{},
	{},
	FieldsPageEntrypointProps
>;

export const fieldSettingsPageEntrypoint: EntryPoint<
	FieldSettingsPageEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<FieldSettingsPageEntrypointComponent>(
		/* webpackChunkName: "async-project-settings-fields-entrypoint" */ './FieldsPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context }: EntryPointRouteParams) => ({
		queries: {},
		extraProps: { context },
	}),
});
